<div
  class="faq-container"
  [ngClass]="{
    right: position === 'right',
    center: position === 'center'
  }"
>
  <button
    mat-button
    class="full-width-xs"
    [ngClass]="{
      'no-border': buttonStyle === 'textOnly',
      white: buttonStyle === 'default'
    }"
    (click)="showFaq()"
    id="btn-faq"
    appBlurOnMouseClick
  >
    <div class="button-container">
      <svg class="button-icon-left" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="question-circle-copy" stroke="currentColor" stroke-width="1.5">
            <path
              vector-effect="non-scaling-stroke"
              d="M9,9 C9.00029133,7.47442919 10.1454538,6.19201013 11.6612688,6.01975736 C13.1770839,5.8475046 14.5807925,6.84027747 14.9233788,8.32688466 C15.2659652,9.81349185 14.438322,11.3204764 13,11.829 C12.4004081,12.0409876 11.9996666,12.6080369 12,13.244 L12,14.25"
              id="Path"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              vector-effect="non-scaling-stroke"
              d="M12,17.25 C11.7928932,17.25 11.625,17.4178932 11.625,17.625 C11.625,17.8321068 11.7928932,18 12,18 C12.2071068,18 12.375,17.8321068 12.375,17.625 C12.375,17.4178932 12.2071068,17.25 12,17.25 L12,17.25"
              id="Path"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <circle vector-effect="non-scaling-stroke" id="Oval" cx="12" cy="12" r="11.25"></circle>
          </g>
        </g>
      </svg>
      {{ 'faq.btn' | translate }}
    </div>
  </button>
</div>
